module.exports = __webpack_public_path__ + "img/empty.bbcfaa38.svg";